<form-layout [showSave]="false" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()">
    <div>
        <kendo-grid [data]="gridView" [sort]="sort" [sortable]="true" (remove)="removeHandler($event)">
            <kendo-grid-column [width]="95">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <button [title]="'aenderungsantrag.grid.open' | translate" class="secondary-button" (click)="openAenderungsantrag(dataItem.id)"
                        [attr.aria-labelledby]="'rowheader-' + rowIndex + ' open-label'">
                        <i-lucide name="external-link" [size]="20"></i-lucide>
                    </button>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="{{'aenderungsantrag.typ' | translate}}" field="typ" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem?.typ != null || dataItem?.typ != ''" [attr.id]="'rowheader-' + rowIndex">
                        <span>
                            {{ formatTyp(dataItem?.typ) }}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="{{'aenderungsantrag.erstelltAm' | translate}}" field="createdOn" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem?.createdOn != null || dataItem?.createdOn != ''"
                        [attr.aria-labelledby]="'rowheader-' + rowIndex">
                        <span>
                            {{ dataItem?.createdOn | date: languageService.GetCurrentShortDateFormat() }}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="{{'aenderungsantrag.status' | translate}}" field="status" [width]="120">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div *ngIf="dataItem?.status != null || dataItem?.status != ''" [attr.aria-labelledby]="'rowheader-' + rowIndex">
                        <span>
                            {{ formatStatus(dataItem?.status) }}
                        </span>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-command-column [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew" let-rowIndex="rowIndex">
                    <button *ngIf="canBeDeleted(dataItem)" kendoGridRemoveCommand [title]="'aenderungsantrag.grid.delete' | translate"
                        [attr.aria-labelledby]="'rowheader-' + rowIndex + ' delete-label'" class="secondary-button">
                        <i class="fa fa-trash"></i>
                    </button>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
    </div>

    <div class="mt-4">
        <button kendoButton class="primary-button" (click)="createHandler()" *ngIf="!isFormOpen">
            <span translate>aenderungsantrag.grid.add</span>
            <i class="fa fa-plus" style="margin-left: 0.5rem;"></i>
        </button>
    </div>

    <form [formGroup]="form" *ngIf="isFormOpen">
        <div class="aenderungsantrag-grid">
            <div class="combobox-field">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="typ" text="{{'aenderungsantrag.typ' | translate}} *"
                        [infotooltip]="'aenderungsantrag.typ'"></kendo-label>
                    <kendo-combobox #antragsTypDropdown formControlName="typ" #typ [valuePrimitive]="true" [allowCustom]="false"
                        [data]="typItems" [valueField]="'Value'" [textField]="'Description'"
                        [appinfotext]="'aenderungsantrag.typ'" kendoDropDownFilter>
                    </kendo-combobox>
                </kendo-formfield>
            </div>
        </div>

        <div class="aenderungsantrag-button-group">
            <button kendoButton class="secondary-button" (click)="cancelForm()">
                {{'schedule-data.dialog.cancel' | translate}}
            </button>
            <button kendoButton class="primary-button" (click)="createAenderungsantrag()" [disabled]="!form.valid">
                {{'aenderungsantrag.create' | translate}}
            </button>
        </div>
    </form>

</form-layout>